import {
  IStyle,
  IStyleFunction,
  IStyleFunctionOrObject,
} from "@fluentui/react";
import { IAppBaseStyleProps, IAppBaseStyles, IAppTokens } from "../../Base";
import { ComponentStylesLoader } from "../../ComponentBase/ComponentStylesLoader";
import { IComponentBaseClassNames } from "../../ComponentBase/IComponentBaseClassNames";

export interface IModalWithSimpleBannerSubComponentStyles {}

export interface IModalWithSimpleBannerStyles
  extends IAppBaseStyles<IModalWithSimpleBannerSubComponentStyles> {
  logo: IStyle;
  modalLine: IStyle;
  iconButtonStyles: IStyle;
}

export interface IModalWithSimpleBannerStyleProps
  extends IAppBaseStyleProps<IAppTokens> {}

export const getModalWithSimpleBannerClassNames = (
  styles?: IStyleFunctionOrObject<
    IModalWithSimpleBannerStyleProps,
    IModalWithSimpleBannerStyles
  >,
  props?: IModalWithSimpleBannerStyleProps
): IComponentBaseClassNames<
  IModalWithSimpleBannerStyleProps,
  IModalWithSimpleBannerStyles,
  IModalWithSimpleBannerSubComponentStyles
> => {
  return ComponentStylesLoader.getComponentClassNames<
    IModalWithSimpleBannerStyleProps,
    IModalWithSimpleBannerStyles,
    IModalWithSimpleBannerSubComponentStyles
  >(styles, props);
};

export const getStyles: IStyleFunction<
  IModalWithSimpleBannerStyleProps,
  IModalWithSimpleBannerStyles
> = (props: IModalWithSimpleBannerStyleProps): IModalWithSimpleBannerStyles => {
  return {
    logo: {
      maxHeight: 50,
    },

    modalLine: {
      "border-bottom-style": "solid",
      "border-bottom-width": "medium",
      "border-bottom-color": "darkblue",
    },

    iconButtonStyles: {
      root: {
        color: props.theme.palette.neutralPrimary,
        marginLeft: "auto",
        marginTop: "4px",
        marginRight: "2px",
      },
    },
  };
};
